import React, {useContext} from 'react';
import { Button } from '@mui/material';
import InputEmail from '../../../common/components/Inputs/InputEmail';
import WithActions from "../../../common/components/Wrappers/WithActions";
import ButtonPrimary from "../../../common/components/Buttons/ButtonPrimary";
import Box from "@mui/material/Box";
import DisabledFormState from "../../../common/components/Wrappers/DisabledFormState";
import {ThemeContext} from "styled-components";

const EmailMiniForm = ({
    email,
    onChangeAuthForm,
    onSubmit,
    disabled = false,
    isLoading = false,
    isCompleted = false
}) => {
    const theme = useContext(ThemeContext);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isLoading) {
            return;
        }
        onSubmit();
    };

    if (disabled) {
        return <DisabledFormState message="Email Sent" tooltip="Added" />
    }

    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                minHeight: 0,
                opacity: disabled ? 0.6 : 1,
                pointerEvents: disabled ? 'none' : 'auto',
                borderRadius: '8px',
                transition: 'all 0.3s ease'
            }}
        >
            {/* Form fields - Scrollable area */}
            <Box
                sx={{
                    flex: '1 1 auto',
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    overflowY: 'auto',
                    mb: 2
                }}
            >
                <WithActions
                    showSuccessButton={isCompleted}
                    isVisible={true}
                    successTooltip="submitted"
                    inputType={disabled ? 'code' : 'text'}
                    forceSpacing={true}
                >
                    {(disabled) && (
                        <div style={{
                            height: '40px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            verification code sent
                        </div>
                    ) || (
                        <InputEmail
                            email={email || ''}
                            onEmailChange={onChangeAuthForm}
                            disabled={disabled}
                            showValidation={false}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    handleSubmit(e);
                                }
                            }}
                        />
                    )}
                </WithActions>
            </Box>

            {/* Button - Pinned at bottom of shadowed container */}
            {(!disabled) && (
                <Box
                    sx={{
                        flexShrink: 0,
                        pt: 2,
                        pb: 2
                    }}
                >
                    <WithActions forceSpacing={true} isButton={true}>
                        <ButtonPrimary
                            type="submit"
                            disabled={disabled || isLoading}
                        >
                            Reset Password
                        </ButtonPrimary>
                    </WithActions>
                </Box>
            )}
        </Box>
    );
};

export default EmailMiniForm;
